import React from 'react';
import { formatOrderDateToLocalTime } from '../../../util';

const FormattedDate = (props) => {
  const { orderingSystem, date } = props;
  const formattedDate = formatOrderDateToLocalTime(date, orderingSystem);

  return <>{formattedDate}</>;
};

export default React.memo(FormattedDate);
